export default __webpack_public_path__ + "static/media/GoQuiz.126559da.png";